import $ from 'jquery/src/jquery';

export default () => {
    const nodeSelectors = {
        container: '[js-site-header="container"]',
    }

    function init() {
        if (!document.querySelector(nodeSelectors.container)) {
            return
        }

        initHeader()
    }

    function initHeader() {
        let scrollDirectionDown = true
        var currentScroll = $(window).scrollTop();

        if(currentScroll > 20 && !$(nodeSelectors.container).hasClass('nav-is-active')){
            $('#site-header').addClass('scrolled')
        } else{
            $('#site-header').removeClass('scrolled')
        }

        window.addEventListener('scroll', function() {
            /**
             * Hide/Show header on scroll
             * If user scrolls down header will be hidden or if user scrolls up header will be visible
             */
            scrollDirectionDown = this.oldScroll <= this.scrollY
            this.oldScroll = this.scrollY

            if(window.scrollY > 20 && !$(nodeSelectors.container).hasClass('nav-is-active')){
                $('#site-header').addClass('scrolled')
            } else{
                $('#site-header').removeClass('scrolled')
            }

            // if ( scrollDirectionDown ) {
            //     // Scrolling down
            //     if(window.scrollY > 100 && !$(nodeSelectors.container).hasClass('nav-is-active'))
            //         hideHeader()
            // } else {
            //     showHeader()
            // }
            /**
             * Hide/Show header on scroll END
             */
        })
    }

    function showHeader() {
        document.querySelector(nodeSelectors.container).style.top = '0px'
    }

    function hideHeader() {
        document.querySelector(nodeSelectors.container).style.top = - document.querySelector(nodeSelectors.container).offsetHeight + 'px'
    }

    return Object.freeze({
        init,
        nodeSelectors,
        showHeader,
        hideHeader
    })
}